<template>
  <div class="task-sidebar-link-wrapper">
    <router-link to="/tasks">
      <b-iconstack font-scale="2.5" class="cursor-pointer">
        <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
        <b-icon stacked icon="kanban" scale="0.5" variant="brown"></b-icon>
      </b-iconstack>
    </router-link>

    <div
      v-if="calcActiveTasks.length > 0"
      class="task-sidebar-link-badge task-sidebar-link-badge-right"
      @click="isSidebarOpen = !isSidebarOpen"
    >
      <b-badge pill variant="light">{{ calcActiveTasks.length }}</b-badge>
    </div>

    <div
      v-if="false"
      class="task-sidebar-link-badge task-sidebar-link-badge-left"
    >
      <b-badge pill variant="light">0</b-badge>
    </div>

    <b-sidebar
      v-model="isSidebarOpen"
      id="notification-sidebar"
      right
      backdrop
      no-close-on-route-change
      width="30em"
    >
      <template #title>
        <div class="title-sidebar">
          <strong class="ml-2">Задачи</strong>
        </div>
      </template>
      <div>
        <div class="d-flex">
          <b-form-radio-group
            id="btn-radios-1"
            v-model="selected"
            :options="options"
            name="radios-btn-default"
            button-variant="outline-primary"
            class="w-100 border-5 filter-value-notification mb-3"
            buttons
            @change="updateChecked"
          >
          </b-form-radio-group>
        </div>

        <div v-if="calcSelectedTasks.length">
          <div
            v-for="(task, index) in calcSelectedTasks"
            :key="index"
            class="d-flex"
          >
            <SidebarTask
              :key="task.id"
              :task="task"
            />
          </div>
        </div>

        <div v-else class="text-center pb-3 pt-2">
          <span class="text-secondary text-uppercase">Задачи отсутствуют</span>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarTask from '@/components/task/SidebarTask.vue';
export default {
  components: {
    SidebarTask,
  },
  data() {
    return {
      activeTasks: {},
      isSidebarOpen: false,
      selected: 0,
      options: [
        { text: 'Все', value: 0 },
        { text: 'Встречи', value: 404 },
        { text: 'Связаться', value: 405 },
        { text: 'Другие', value: 406 }
      ],
    }
  },
  watch: {
    isSidebarOpen() {
      if (this.isSidebarOpen) {
        this.getActiveTasks()
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser', 'isAuthenticated']),
    calcActiveTasks() {
      let arr = [];
      for (let key in this.activeTasks) {
        if (this.activeTasks[key].length) {
          this.activeTasks[key].forEach(t => arr.push(t))
        }
      }
      return arr
    },
    calcSelectedTasks() {
      if (this.selected === 0) {
        return this.calcActiveTasks
      }
      return this.calcActiveTasks.filter(t => t.type.id === this.selected)
    },
  },
  methods: {
    getActiveTasks() {
      axios
        .get('/api/tasks/get-active-tasks-in-notification')
        .then(({ data }) => {
          this.activeTasks = data;
      });
    },
    setUnreadInterval() {
      setInterval(() => {
        if (this.isAuthenticated) {
          this.getActiveTasks();
        }
      }, 30000);
    },
    updateChecked() {
      const temp = this.selected;
      this.selected = null;
      this.selected = temp;
    },
  },
  mounted() {
    this.getActiveTasks();
    this.setUnreadInterval();
  },
}
</script>

<style>
.task-sidebar-link-wrapper {
  position: relative;
}
.task-sidebar-link-badge {
  position: absolute;
  top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  z-index: 1;
  font-size: 12px;
  cursor: pointer;
}
.task-sidebar-link-badge-right {
  right: -6.5px;
}
.task-sidebar-link-badge-left {
  left: -6.5px;
}
</style>